import * as React from 'react';
import {
  TopBarRoot,
  TopBarDesktop,
  TopBarMobile,
  LogoWrap,
  LogoImg,
  TopBarSpacer,
  TaglineText,
  TopBarCounter,
  NavRowRoot,
  BackBtn,
  ReturnLater,
  NavCounter,
} from './header.styled';

const BackArrowIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19 12H5M5 12L12 19M5 12L12 5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* ─── Top Bar ─── */

type FpTopBarProps = {
  counterLabel: string;
};

export const FpTopBar: React.FC<FpTopBarProps> = ({ counterLabel }) => {
  return (
    <TopBarRoot>
      {/* Desktop */}
      <TopBarDesktop>
        <LogoWrap>
          <LogoImg src="/main-logo-white.svg" alt="Mailander" />
        </LogoWrap>
        <TopBarSpacer />
        <TaglineText>Decision Intelligence. CEO Performance.</TaglineText>
        <TopBarCounter>{counterLabel}</TopBarCounter>
      </TopBarDesktop>

      {/* Mobile */}
      <TopBarMobile>
        <LogoWrap>
          <LogoImg $mobile src="/main-logo-white.svg" alt="Mailander" />
        </LogoWrap>
        <TaglineText $mobile>Decision Intelligence. CEO Performance.</TaglineText>
      </TopBarMobile>
    </TopBarRoot>
  );
};

/* ─── Nav Row ─── */

type FpNavRowProps = {
  counterLabel: string;
  canGoBack: boolean;
  onBack: () => void;
  onReturnLater: () => void;
};

export const FpNavRow: React.FC<FpNavRowProps> = ({
  counterLabel,
  canGoBack,
  onBack,
  onReturnLater,
}) => {
  return (
    <NavRowRoot>
      <BackBtn type="button" onClick={onBack} disabled={!canGoBack} aria-label="Go back">
        <BackArrowIcon />
      </BackBtn>

      {/* Counter visible only on mobile */}
      <NavCounter>{counterLabel}</NavCounter>

      <ReturnLater type="button" onClick={onReturnLater}>
        Return later
      </ReturnLater>
    </NavRowRoot>
  );
};
